var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex items-center",staticStyle:{"flex-shrink":"0"},style:({
    padding: _vm.S.togglePad,
    borderRadius: _vm.S.toggleRadius,
    background: _vm.T.toggle.bg,
    border: '1px solid ' + _vm.T.toggle.border,
  }),attrs:{"role":"group","aria-label":"View mode"}},_vm._l((_vm.options),function(opt){return _c('button',{key:opt.value,staticClass:"ga-toggle-btn flex-center transition-colors duration-150",class:{ 'is-on': _vm.value === opt.value },style:({
      width: _vm.S.toggleBtn,
      height: _vm.S.toggleBtn,
      borderRadius: _vm.S.toggleInnerRadius,
      background: _vm.value === opt.value ? _vm.T.toggle.onBg : 'transparent',
      border:
        '1px solid ' + (_vm.value === opt.value ? _vm.T.toggle.onBorder : 'transparent'),
      color: _vm.value === opt.value ? _vm.T.toggle.onIcon : _vm.T.toggle.offIcon,
      '--ga-toggle-hover': _vm.T.toggle.offIconHover,
    }),attrs:{"type":"button","title":opt.label,"aria-label":opt.label,"aria-pressed":_vm.value === opt.value ? 'true' : 'false'},on:{"click":function($event){return _vm.$emit('input', opt.value)}}},[_c('ga-icon',{style:({ width: _vm.S.icon, height: _vm.S.icon }),attrs:{"name":opt.icon,"stroke":2.25}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }